<template>
  <div class="page-container appstore_wrap">
    <store-header
      tabs="docs"
      :showDoc="true"
      :defaultMarket="defaultMarketDomain"
    ></store-header>
    <div class="section">
      <div class="w1200">
        <el-row>
          <el-col :span="5">
            <div class="menu">
              <div class="titleBox">参考文档</div>
              <ul class="faq_kinds" id="menu_list">
                <li
                  :class="activeShow == item.path ? 'active' : ''"
                  v-for="item in documents"
                  :key="item.path"
                  :title="item.title"
                >
                  <router-link
                    :to="{ name: 'docshow', params: { path: item.path } }"
                    >{{ item.title }}</router-link
                  >
                </li>
              </ul>
            </div>
          </el-col>
          <el-col :span="19">
            <div class="context-left">
              <div
                class="action"
                v-if="userInfo && userInfo.eid == manageDocEID"
              >
                <a
                  @click="
                    () => {
                      this.document = {};
                      this.edit = true;
                    }
                  "
                  v-if="!edit"
                  >新增文档</a
                >
                <a
                  @click="
                    () => {
                      this.edit = true;
                    }
                  "
                  v-if="this.document.docID && !edit"
                  >编辑文档</a
                >
                <a
                  @click="() => deleteDoc(this.document.docID)"
                  v-if="this.document.docID && !edit"
                >
                  <i class="el-icon-delete"></i>
                </a>
                <a @click="submitDoc" v-if="edit">保存</a>
              </div>
              <div class="content-edit" v-if="edit">
                <el-form
                  ref="form"
                  :rules="rules"
                  :model="document"
                  label-width="80px"
                >
                  <el-row>
                    <el-col :span="12">
                      <el-form-item prop="title" label="标题">
                        <el-input v-model="document.title"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="path" label="路径">
                        <el-input v-model="document.path"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item prop="description" label="简介">
                        <el-input
                          type="textarea"
                          v-model="document.description"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-form-item prop="content" label="正文">
                      <edit
                        placeholder="编辑文档内容"
                        v-model="document.content"
                      ></edit>
                    </el-form-item>
                  </el-row>
                </el-form>
              </div>
              <div
                v-else
                class="content"
                id="content"
                v-html="document.content"
              ></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  fetchDocumentList,
  fetchDocumentDeatil,
  deleteDocument,
  createDocument,
  updateDocument
} from '@/api/document';
import { errorHandle } from '../../utils/error';
export default {
  name: 'Docs',
  data() {
    return {
      activeShow: '',
      edit: false,
      document: {},
      documents: [],
      rules: {
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' },
          { min: 2, message: '至少两个字符', trigger: 'blur' },
          { max: 24, message: '标题建议不超过24个字符', trigger: 'blur' }
        ],
        path: [
          { required: true, message: '路径不能为空', trigger: 'blur' },
          { min: 2, message: '至少两个字符', trigger: 'blur' },
          { max: 20, message: '路径建议不超过20个字符', trigger: 'blur' }
        ]
      }
    };
  },
  watch: {
    $route: 'changePath'
  },
  methods: {
    submitDoc() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.document.docID) {
            updateDocument(this.document)
              .then((re) => {
                this.document = re;
                this.$message.success('编辑成功');
                this.edit = false;
              })
              .catch((err) => {
                errorHandle(err);
              });
          } else {
            createDocument(this.document)
              .then((re) => {
                this.document = re;
                this.$message.success('新建成功');
                this.fetchDocuments();
                this.edit = false;
              })
              .catch((err) => {
                errorHandle(err);
              });
          }
        }
      });
    },
    deleteDoc(id) {
      this.$confirm('确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDocument({ docID: id })
          .then(() => {
            this.$message.success('删除成功');
            this.fetchDocuments();
          })
          .catch((err) => {
            errorHandle(err);
          });
      });
    },
    changePath() {
      const path = this.$route.params.path;
      if (path) {
        this.activeShow = path;
        this.getContent(path);
      }
    },
    getContent(docID) {
      this.loadDocument = true;
      fetchDocumentDeatil({ docID: docID })
        .then((re) => {
          this.document = re;
          this.loadDocument = false;
        })
        .catch((err) => {
          if (err.code == 17001) {
            this.$router.push({ name: '404' });
          }

          this.loadDocument = false;
        });
    },
    fetchDocuments() {
      this.loadDocuments = true;
      fetchDocumentList()
        .then((re) => {
          if (re) {
            this.documents = re.documents;
            if (
              !this.activeShow &&
              this.documents &&
              this.documents.length > 0
            ) {
              this.activeShow = this.documents[0].path;
              this.getContent(this.activeShow);
            }
          }
          this.loadDocuments = false;
        })
        .catch((err) => {
          this.loadDocuments = false;
        });
    }
  },
  created() {
    this.fetchDocuments();
    this.changePath();
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    defaultMarketDomain() {
      return this.$store.state.user.platformInfo.defaultMarketDomain;
    },
    manageDocEID() {
      return this.$store.state.user.platformInfo.docEditEID;
    }
  }
};
</script>
<style lang="scss">
#content {
  padding: 16px;
  font-family: 'PingFang SC', 'Helvetica Neue', 'Hiragino Sans GB', 'Segoe UI',
    'Microsoft YaHei', '微软雅黑', sans-serif;
  -webkit-font-smoothing: antialiased;
  blockquote {
    margin-bottom: 1em;
    color: #464b52;
    line-height: 28px;
    position: relative;
    font-weight: 300;
    border-left: 1px solid #1abc9c;
    padding-left: 1em;
    margin: 1em 3em 1em 2em;
  }
  li {
    text-indent: 28px;
    list-style: circle;
    color: #202d40;
    line-height: 200%;
  }
  p {
    margin: 14px 0;
    text-indent: 28px;
    font-size: 14px;
    font-weight: normal;
    color: #202d40;
    line-height: 200%;
    strong {
      font-weight: 500;
    }
  }
  h1 {
    font-size: 26px;
    font-weight: 600;
    color: #000;
  }
  h2 {
    font-size: 1.5em;
  }

  h1,
  h2 {
    border-bottom: 1px solid #eaecef;
    padding-bottom: 0.3em;
  }
  img {
    max-width: 100%;
    margin-left: -28px;
  }
}
</style>
<style lang="scss" scoped>
.section {
  padding: 80px 0;
  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }
}
.action {
  padding: 16px;
  background: #ffffff;
  text-align: right;
  margin-bottom: 0;
  border-bottom: 1px solid #f5f5f5;
}
.menu,
.context-left {
  margin: 16px;
  min-height: 600px;
  background: #ffffff;
}
.menu,
.content,
.content-edit {
  padding: 16px;
}

.ql-editor {
  min-height: 534px;
}
.menu {
  .titleBox {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 20px;
    border-bottom: 1px solid #f5f5f5;
  }
  .faq_kinds {
    list-style: none;
    li {
      border-bottom: 1px solid #f5f5f5;
      cursor: pointer;
      a {
        cursor: pointer;
        display: block;
        height: 40px;
        color: #000;
        font-size: 15px;
        line-height: 40px;
        text-indent: 8px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        position: relative;
        &:hover {
          color: #409eff;
        }
      }
      &.active {
        background-color: #409eff;
        color: #fff;
        a {
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/docs/index.vue